// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0px;
    padding: 0px;
    font-family: "Open Sans", sans-serif;
    width: 100%;
    height: 100%;
}
.bg-theme{
	background: #358696 !important;
    box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);
}
.headFont{
	font-size: 26px; font-weight: 600; margin-left: 55px; color: #fff;
}

/* .closed-sidebar.fixed-sidebar .app-main__outer{ */
	/* background: linear-gradient(180deg, #358696 0%, rgba(53, 134, 150, 0) 100%) !important; */
    /* height: 100%; */
/* } */

/********* Left Side Menu Section ********/
.fixed-header .app-main {
    padding-top: 80px;
}
.app-sidebar .app-sidebar__inner {
    padding: 20px 0px 0px !important;
}
.app-sidebar .app-sidebar__inner {
    padding: 45px 1.5rem 1.5rem;
    background: linear-gradient(180deg, #358696 0%, rgba(53, 134, 150, 0) 100%) !important; 
    height: 100%;
}
/* .app-sidebar__inner{ */
	/* background: linear-gradient(180deg, #358696 0%, rgba(53, 134, 150, 0) 100%) !important;  */
    /* height: 100%; */
/* } */
/* .app-sidebar{ */
	/* padding-top:80px !important; */
/* } */
.app-header{height:80px !important;}
.colWhite{color:#fff;}
.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after
{background-color:#fff !important;}


.vertical-nav-menu li {
    text-indent: 15px;
    font-weight: 600 !important;
}

.vertical-nav-menu i.metismenu-state-icon, .vertical-nav-menu i.metismenu-icon {
    opacity: 1 !important;
    margin-right: 30px !important;
    top: 22px;
}
/* .vertical-nav-menu span.metismenu-state-icon, .vertical-nav-menu span.metismenu-icon { */
    /* opacity: 1 !important; */
    /* margin-right: 30px !important; */
    /* top: 22px; */
/* } */

.vertical-nav-menu li a {
    color: #fff;
    font-size: 16px;
    font-weight: 600 !important;
    border-radius: 0px;
    margin: 8px 2% 8px 2%;
    text-indent: 10px;
    width: 96%;
    height: 50px;
}
.vertical-nav-menu li a {
    padding: 5px 15px;
    /* text-indent: 25px; */
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-icon {
    text-indent: 20px;
    left: 50%;
    margin-left: 0px;
}
.link-title {
    margin-left: 10px;
}

/********* Left Side Menu Section Ends ********/

/********* Landing 2 Starts ********/
.dashboard_card {
    font-size: 18px;
    color: #000;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    transition: 0.5s;
    background: #fff;
    border: solid 1px #c3c3c3;
    box-shadow: 1px 1px 25px #33333320;
    padding: 45px 15px 45px 15px;
    margin-top: 20px;
    width: 100%;
    /* max-width: 242px; */
}
.dashboard_card img {
    width: 50px;
}
.dashboard_card span {
    display: block;
    padding-top: 15px;
    font-weight: 600;
    line-height: 25px;
}
.dashboard_card:hover {
    box-shadow: 1px 1px 25px #999;
}
.mobLogo img{
	display:none;
}
.MobView{
	display:none;
}


/********* Media Queries Starts ********/


@media screen and (max-width: 991px) {
.app-header .app-header__content {
    visibility: inherit !important;
    opacity: 1 !important;
     box-shadow: none !important; 
    background: transparent !important;
    position: relative !important;
    left: 5%;
     width: 90%; 
    top: 0;
    transition: all .2s;
    background: #fff;
    border-radius: 50px;
    padding: 0 10px;
    overflow: hidden;
}
.app-header__content .dropdown{
	margin-right:30px !important;
}
.app-header__logo{display:none !important;}
}
@media screen and (max-width: 769px) {
  .headFont, .MobView{
	font-size: 1em; font-weight: 600; margin-left: 25px; color: #fff;
}
.MobView{
	margin-left:0 ;
	display:block;
    background: #e2e2e2;
    font-size: 16px;
    color: #000;
    padding: 10px 15px;

}
.headFont{
	display:none;
}
.mobLogo img{
	height:2em;
	margin-left:20px;
	display:block;
}
}
@media screen and (max-width: 420px) {

.mobLogo img{
	height:1.5em;
	margin-left:10px;
}
}

.ev_card_title span{
 font-size: 18px;
}
.accordion-button:not(.collapsed) {
    /* color: #0c63e4; */
    /* background-color: #e7f1ff; */
    box-shadow: inset  0 0  0.25rem rgb(53 134 150 / 43%);
    
}
.accordion-button:focus {
    /* z-index: 3; */
    /* border-color: #86b7fe; */
    /* outline: 0; */
    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 43%);
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/LayoutMain/LayoutMain_.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,WAAW;IACX,YAAY;AAChB;AACA;CACC,8BAA8B;IAC3B,wCAAwC;AAC5C;AACA;CACC,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,WAAW;AAClE;;AAEA,oDAAoD;CACnD,4FAA4F;IACzF,kBAAkB;AACtB,MAAM;;AAEN,0CAA0C;AAC1C;IACI,iBAAiB;AACrB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,2BAA2B;IAC3B,sFAAsF;IACtF,YAAY;AAChB;AACA,yBAAyB;CACxB,6FAA6F;IAC1F,kBAAkB;AACtB,MAAM;AACN,kBAAkB;CACjB,iCAAiC;AAClC,MAAM;AACN,YAAY,sBAAsB,CAAC;AACnC,UAAU,UAAU,CAAC;AACrB;CACC,gCAAgC,CAAC;;;AAGlC;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,SAAS;AACb;AACA,2FAA2F;IACvF,2BAA2B;IAC3B,mCAAmC;IACnC,eAAe;AACnB,MAAM;;AAEN;IACI,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,UAAU;IACV,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA,+CAA+C;;AAE/C,oCAAoC;AACpC;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;IAClC,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,6BAA6B;AACjC;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;;;AAGA,wCAAwC;;;AAGxC;AACA;IACI,8BAA8B;IAC9B,qBAAqB;KACpB,2BAA2B;IAC5B,kCAAkC;IAClC,6BAA6B;IAC7B,QAAQ;KACP,UAAU;IACX,MAAM;IACN,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;CACC,4BAA4B;AAC7B;AACA,kBAAkB,uBAAuB,CAAC;AAC1C;AACA;EACE;CACD,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,WAAW;AACjE;AACA;CACC,cAAc;CACd,aAAa;IACV,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,kBAAkB;;AAEtB;AACA;CACC,YAAY;AACb;AACA;CACC,UAAU;CACV,gBAAgB;CAChB,aAAa;AACd;AACA;AACA;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;AACA;;AAEA;CACC,eAAe;AAChB;AACA;IACI,oBAAoB;IACpB,+BAA+B;IAC/B,qDAAqD;;AAEzD;AACA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,+CAA+C;AACnD","sourcesContent":["body {\r\n    margin: 0px;\r\n    padding: 0px;\r\n    font-family: \"Open Sans\", sans-serif;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n.bg-theme{\r\n\tbackground: #358696 !important;\r\n    box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);\r\n}\r\n.headFont{\r\n\tfont-size: 26px; font-weight: 600; margin-left: 55px; color: #fff;\r\n}\r\n\r\n/* .closed-sidebar.fixed-sidebar .app-main__outer{ */\r\n\t/* background: linear-gradient(180deg, #358696 0%, rgba(53, 134, 150, 0) 100%) !important; */\r\n    /* height: 100%; */\r\n/* } */\r\n\r\n/********* Left Side Menu Section ********/\r\n.fixed-header .app-main {\r\n    padding-top: 80px;\r\n}\r\n.app-sidebar .app-sidebar__inner {\r\n    padding: 20px 0px 0px !important;\r\n}\r\n.app-sidebar .app-sidebar__inner {\r\n    padding: 45px 1.5rem 1.5rem;\r\n    background: linear-gradient(180deg, #358696 0%, rgba(53, 134, 150, 0) 100%) !important; \r\n    height: 100%;\r\n}\r\n/* .app-sidebar__inner{ */\r\n\t/* background: linear-gradient(180deg, #358696 0%, rgba(53, 134, 150, 0) 100%) !important;  */\r\n    /* height: 100%; */\r\n/* } */\r\n/* .app-sidebar{ */\r\n\t/* padding-top:80px !important; */\r\n/* } */\r\n.app-header{height:80px !important;}\r\n.colWhite{color:#fff;}\r\n.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after\r\n{background-color:#fff !important;}\r\n\r\n\r\n.vertical-nav-menu li {\r\n    text-indent: 15px;\r\n    font-weight: 600 !important;\r\n}\r\n\r\n.vertical-nav-menu i.metismenu-state-icon, .vertical-nav-menu i.metismenu-icon {\r\n    opacity: 1 !important;\r\n    margin-right: 30px !important;\r\n    top: 22px;\r\n}\r\n/* .vertical-nav-menu span.metismenu-state-icon, .vertical-nav-menu span.metismenu-icon { */\r\n    /* opacity: 1 !important; */\r\n    /* margin-right: 30px !important; */\r\n    /* top: 22px; */\r\n/* } */\r\n\r\n.vertical-nav-menu li a {\r\n    color: #fff;\r\n    font-size: 16px;\r\n    font-weight: 600 !important;\r\n    border-radius: 0px;\r\n    margin: 8px 2% 8px 2%;\r\n    text-indent: 10px;\r\n    width: 96%;\r\n    height: 50px;\r\n}\r\n.vertical-nav-menu li a {\r\n    padding: 5px 15px;\r\n    /* text-indent: 25px; */\r\n}\r\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-icon {\r\n    text-indent: 20px;\r\n    left: 50%;\r\n    margin-left: 0px;\r\n}\r\n.link-title {\r\n    margin-left: 10px;\r\n}\r\n\r\n/********* Left Side Menu Section Ends ********/\r\n\r\n/********* Landing 2 Starts ********/\r\n.dashboard_card {\r\n    font-size: 18px;\r\n    color: #000;\r\n    font-weight: 600;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    transition: 0.5s;\r\n    background: #fff;\r\n    border: solid 1px #c3c3c3;\r\n    box-shadow: 1px 1px 25px #33333320;\r\n    padding: 45px 15px 45px 15px;\r\n    margin-top: 20px;\r\n    width: 100%;\r\n    /* max-width: 242px; */\r\n}\r\n.dashboard_card img {\r\n    width: 50px;\r\n}\r\n.dashboard_card span {\r\n    display: block;\r\n    padding-top: 15px;\r\n    font-weight: 600;\r\n    line-height: 25px;\r\n}\r\n.dashboard_card:hover {\r\n    box-shadow: 1px 1px 25px #999;\r\n}\r\n.mobLogo img{\r\n\tdisplay:none;\r\n}\r\n.MobView{\r\n\tdisplay:none;\r\n}\r\n\r\n\r\n/********* Media Queries Starts ********/\r\n\r\n\r\n@media screen and (max-width: 991px) {\r\n.app-header .app-header__content {\r\n    visibility: inherit !important;\r\n    opacity: 1 !important;\r\n     box-shadow: none !important; \r\n    background: transparent !important;\r\n    position: relative !important;\r\n    left: 5%;\r\n     width: 90%; \r\n    top: 0;\r\n    transition: all .2s;\r\n    background: #fff;\r\n    border-radius: 50px;\r\n    padding: 0 10px;\r\n    overflow: hidden;\r\n}\r\n.app-header__content .dropdown{\r\n\tmargin-right:30px !important;\r\n}\r\n.app-header__logo{display:none !important;}\r\n}\r\n@media screen and (max-width: 769px) {\r\n  .headFont, .MobView{\r\n\tfont-size: 1em; font-weight: 600; margin-left: 25px; color: #fff;\r\n}\r\n.MobView{\r\n\tmargin-left:0 ;\r\n\tdisplay:block;\r\n    background: #e2e2e2;\r\n    font-size: 16px;\r\n    color: #000;\r\n    padding: 10px 15px;\r\n\r\n}\r\n.headFont{\r\n\tdisplay:none;\r\n}\r\n.mobLogo img{\r\n\theight:2em;\r\n\tmargin-left:20px;\r\n\tdisplay:block;\r\n}\r\n}\r\n@media screen and (max-width: 420px) {\r\n\r\n.mobLogo img{\r\n\theight:1.5em;\r\n\tmargin-left:10px;\r\n}\r\n}\r\n\r\n.ev_card_title span{\r\n font-size: 18px;\r\n}\r\n.accordion-button:not(.collapsed) {\r\n    /* color: #0c63e4; */\r\n    /* background-color: #e7f1ff; */\r\n    box-shadow: inset  0 0  0.25rem rgb(53 134 150 / 43%);\r\n    \r\n}\r\n.accordion-button:focus {\r\n    /* z-index: 3; */\r\n    /* border-color: #86b7fe; */\r\n    /* outline: 0; */\r\n    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 43%);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
